import { render } from "./DenominationView.vue?vue&type=template&id=42b9cb80"
import script from "./DenominationView.vue?vue&type=script&lang=js"
export * from "./DenominationView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__